import { useModelExporter } from '#imports';
import { Color, NearestMipmapLinearFilter, RepeatWrapping, SRGBColorSpace, Vector2 } from 'three';
import { onMounted, ref, watch } from 'vue';

import { KTXLoader } from '@resn/gozer-loading';
import { usePane } from '@resn/gozer-vue';

import { createPackSceneObjectMaterial } from '../../materials/PackSceneObjectMaterial';
import { useBaseObject } from './useBaseObject';

export const useBaseball = ({ object }) => {
    const inner = object.getObjectByName('baseball-inner');
    const main = object.getObjectByName('baseball-main');

    const normalMap = main.material.normalMap;
    normalMap.minFilter = NearestMipmapLinearFilter; //LinearMipmapLinearFilter;
    normalMap.needsUpdate = true;

    const material = createPackSceneObjectMaterial(
        {
            roughness: 0.8,
            metalness: 0.2,
            normalMap,
            map: main.material.map,
        },
        {
            uMaskColor: { value: new Color('red') },
            uMaskRoughnessFactor: { value: 0.8 },
            uMaskMetalnessFactor: { value: 0.3 },
        }
    );
    material.defines.USE_MASK = '';

    main.material = material;

    useBaseObject({ object, name: 'Baseball' });

    onMounted(() => {
        window.baseball = main;
        window.baseballMaterial = main.material;
    });

    const loader = new KTXLoader(
        '/textures/pack/3d/baseball/baseball-stitches-alpha-1024-etc1s.ktx2'
    );
    loader.start().then((texture) => {
        texture.flipY = false;

        material.uMaskMap = texture;
    });

    return {
        inner,
        main,
        material,
    };
};
